import axios, { AxiosResponse } from 'axios';
import EnvWindow from '../../utils/env';
import { addParam } from '../../utils/servicesHelper';
import { ContextualHelpDetails, ContextualHelpFilter, ContextualHelpResult, ContextualHelpSortBy } from './contextualHelp.types';

const defaultFilter = {
  id: '',
  area: '',
  section: '',
  title: '',
  active: [true],
};

const contactDataUrl = `${EnvWindow.REACT_APP_SUPPORT_API_URL}/ContextualHelp`;

export async function getContextualHelpDetails(
  contextualHelpId: number,
): Promise<AxiosResponse<ContextualHelpDetails>> {
  return await axios.get(`${contactDataUrl}/${contextualHelpId}`);
}

export async function getContextualHelpList(
  filter: ContextualHelpFilter = defaultFilter,
  sortByColumnId: ContextualHelpSortBy = 'area',
  isDescending = true,
  signal?: AbortSignal,
): Promise<ContextualHelpDetails[]> {
  let params = '';
  params += addParam('title', filter.title ? filter.title : '');
  params += addParam('section', filter.section ? filter.section : '');
  params += addParam('area', filter.area ? filter.area : '');
  params += addParam('sortBy', sortByColumnId);
  params += addParam('descending', isDescending ? 'true' : 'false');

  const response = await axios.get(`${contactDataUrl}?${params}`, {
    signal: signal ?? undefined,
  });
  return response.data;
}

export async function updateContextualHelp(
  id: string,
  title: string,
  description: string,
  url?: string
): Promise<AxiosResponse<ContextualHelpResult>> {
  const response = await axios.put(contactDataUrl,
    {
      id: id,
      title: title,
      description: description,
      url: url
    }
  );
  return response.data;
}
